import { useTranslation } from "react-i18next";
import dashboardImg from "../../assets/dashboard-mockup.jpg";
import mobileImg from "../../assets/mobile-mockup.jpg";
import ScrollReveal from "./ScrollReveal";

const ShowcaseSection = () => {
  const { t } = useTranslation();

  return (
    <section className="assist-section">
      <div className="assist-container">
        <ScrollReveal className="assist-section-head">
          <p className="assist-section-eyebrow">{t("showcase.badge", "Produit")}</p>
          <h2 className="assist-section-title">{t("showcase.title", "Web + Mobile, une seule plateforme")}</h2>
          <p className="assist-section-text">
            {t(
              "showcase.subtitle",
              "L'administrateur configure et supervise depuis le tableau de bord web. Les techniciens et utilisateurs scannent et interviennent depuis l'application mobile."
            )}
          </p>
        </ScrollReveal>

        <div className="assist-showcase-grid">
          <ScrollReveal className="assist-showcase-phone">
            <div className="assist-showcase-frame assist-showcase-frame-phone">
              <img
                src={mobileImg}
                alt="Application mobile AssistByScan"
                className="assist-media-img"
                loading="lazy"
                width="900"
                height="1600"
              />
            </div>
          </ScrollReveal>

          <ScrollReveal className="assist-showcase-dashboard" delay={120}>
            <div className="assist-showcase-frame">
              <img
                src={dashboardImg}
                alt="Dashboard web AssistByScan"
                className="assist-media-img"
                loading="lazy"
                width="1600"
                height="1000"
              />
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
};

export default ShowcaseSection;